import { useState } from "react";
import { WAITLIST_API_URL } from "../Data/apiEndpoints";
import { alerts } from "../Data/siteContent";

export default function useWaitingListSignup(productName) {
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState({ isVisible: false, type: "error", title: "", message: "" });

  const handleEmailChange = e => {
    setEmail(e.target.value);
  };

  const closeFeedback = () => {
    setFeedback({ isVisible: false, type: "error", title: "", message: "" });
  };

  const isValidEmail = value => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };

  const handleSubscribe = async () => {
    if (!isValidEmail(email)) {
      setFeedback({ isVisible: true, type: "error", title: "Invalid Email", message: alerts.invalidEmail });
      return;
    }

    try {
      const response = await fetch(WAITLIST_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, product: productName }),
      });
      if (response.ok) {
        setFeedback({
          isVisible: true,
          type: "success",
          title: "Joined Waiting List",
          message: alerts.joinWaitingListMessage,
        });
        setEmail("");
      } else {
        setFeedback({ isVisible: true, type: "error", title: "Subscription Failed", message: alerts.subscribeFailed });
      }
    } catch (error) {
      setFeedback({ isVisible: true, type: "error", title: "Something Went Wrong", message: alerts.subscribeError });
    }
  };

  return { email, handleEmailChange, handleSubscribe, feedback, closeFeedback };
}
